export default __webpack_public_path__ + "static/media/brand-identity.c560f204.svg";